module.exports = __webpack_public_path__ + "static/the-compleat-strategyst-754a2576c2f2ab6c3e1b726eb8f792b8.jpg";